import React from "react";

const EventFilters = ({
  showFilters,
  setShowFilters,
  activeFilterCount,
  tempFilters,
  setTempFilters,
  applyFilters,
  clearFilters,
}) => {
  return (
    <div className="filters-bar-container">
      <div className="filters-headers">
        <button
          className="filters-toggles"
          onClick={() => setShowFilters(!showFilters)}
        >
          <span className="filter-icon">⚙️</span>
          Filters
          {activeFilterCount > 0 && (
            <span className="filter-count">{activeFilterCount}</span>
          )}
          <span className="chevron">{showFilters ? "▲" : "▼"}</span>
        </button>

        {activeFilterCount > 0 && (
          <button className="clear-inline" onClick={clearFilters}>
            Clear all
          </button>
        )}
      </div>

      {showFilters && (
        <div className="filters-grid">
          <div className="filter-group">
            <label>Status</label>
            <select
              value={tempFilters.status}
              onChange={(e) =>
                setTempFilters({ ...tempFilters, status: e.target.value })
              }
            >
              <option value="">All Status</option>
              <option value="todo">To Do</option>
              <option value="inprogress">In Progress</option>
              <option value="done">Done</option>
              <option value="pending">Pending</option>
              <option value="scheduled">Scheduled</option>
              <option value="completed">Completed</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Priority</label>
            <select
              value={tempFilters.priority}
              onChange={(e) =>
                setTempFilters({
                  ...tempFilters,
                  priority: e.target.value,
                })
              }
            >
              <option value="">All Priority</option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Types</label>
            <select
              value={tempFilters.eventType}
              onChange={(e) =>
                setTempFilters({
                  ...tempFilters,
                  eventType: e.target.value,
                })
              }
            >
              <option value="">All Types</option>
              <option value="reminder">Reminder</option>
              <option value="meeting">Meeting</option>
              <option value="health">Health</option>
              <option value="logistics">Logistics</option>
              <option value="maintenance">Maintenance</option>
            </select>
          </div>

          <div className="filter-group">
            <label>Category</label>
            <input
              type="text"
              placeholder="Category"
              value={tempFilters.category}
              onChange={(e) =>
                setTempFilters({
                  ...tempFilters,
                  category: e.target.value,
                })
              }
            />
          </div>

          <div className="filter-group">
            <label>Start Date</label>
            <input
              type="date"
              placeholder="Start Date"
              value={tempFilters.startDate}
              onChange={(e) =>
                setTempFilters({
                  ...tempFilters,
                  startDate: e.target.value,
                })
              }
            />
          </div>

          <div className="filter-group">
            <label>End Date</label>
            <input
              type="date"
              placeholder="End Date"
              value={tempFilters.endDate}
              onChange={(e) =>
                setTempFilters({
                  ...tempFilters,
                  endDate: e.target.value,
                })
              }
            />
          </div>

          <div className="filters-actions">
            <button className="clear-btns" onClick={clearFilters}>
              Reset
            </button>
            <button className="apply-btn" onClick={applyFilters}>
              Apply Filters
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventFilters;
